import WindowResolver from './WindowResolver'


declare global {
  interface Window {
    dataLayer(method: string, ...args: any[]): void
  }
}

/*

 From docs:

 window.dataLayer.push(...)

 Usage:

 dataLayer.push(...)

 */

const windowEntity = 'dataLayer'

const methods = {
  push: true,
}

type DataLayerProprety = number | string | number[] | string[] | { [key: string]: DataLayerProprety }

interface IDataLayerEvent {
  event?: string,
  [key: string]: DataLayerProprety
}

interface IDataLayer {
  push(data: IDataLayerEvent): void
}

const dataLayer = new WindowResolver({
  name: windowEntity,
  methods,
  resolver: () => Boolean(window.dataLayer),
  eventHandler: (methodName, ...args) => {
    window.dataLayer[methodName](...args)
  },
}) as unknown as IDataLayer


export default dataLayer

export {
  windowEntity,
  methods,
}
